import {
  AnalyticsApi as AnalyticsApiGen,
  ConfigApi as ConfigApiGen,
  EnablementApi as EnablementApiGen,
  HypermediaApi as HypermediaApiGen,
  PendoApi as PendoApiGen,
  PowerBiApi as PowerBiApiGen,
  TerminalConnectApi as TerminalConnectApiGen,
  UserApi as UserApiGen,
} from './gen/shared'
import { RestApiConfiguration, LegacyApiConfiguration } from './config'
import { EntityApi as EntityLegacyApiGen } from './gen/legacy'
import { EntityApi as EntityApiGen, UserStorageApi as UserStorageApiGen } from './gen/navigator'

export { data } from './helpers'

export const AnalyticsApi = new AnalyticsApiGen(RestApiConfiguration)
export const ConfigApi = new ConfigApiGen(RestApiConfiguration)
export const EnablementApi = new EnablementApiGen(RestApiConfiguration)
export const HypermediaApi = new HypermediaApiGen(RestApiConfiguration)
export const PendoApi = new PendoApiGen(RestApiConfiguration)
export const PowerBiApi = new PowerBiApiGen(RestApiConfiguration)
export const TerminalConnectApi = new TerminalConnectApiGen(RestApiConfiguration)
export const UserApi = new UserApiGen(RestApiConfiguration)
export const EntityApi = new EntityApiGen(RestApiConfiguration)
export const EntityLegacyApi = new EntityLegacyApiGen(LegacyApiConfiguration)
export const UserStorageApi = new UserStorageApiGen(RestApiConfiguration)
